import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "./Mapview.css"
import Map from "../images/mapicon.svg";

// Map pin images

import EnquiryPin from "./Map_pins/enquiry_pin.png";
import InstallationPin from "./Map_pins/installation_pin.png";
import ComplaintsPin from "./Map_pins/complaints_pin.png";
import DuePin from "./Map_pins/due_pin.png";
import RecoveryPin from "./Map_pins/recovery_pin.png";
import YellowPin from "./Map_pins/yellow_pin.png";
import BlackPin from "./Map_pins/black_pin.png";
import BluePin from "./Map_pins/blue_pin.png";
import BrownPin from "./Map_pins/brown_pin.png";
import GreenPin from "./Map_pins/green_pin.png";
import OrangePin from "./Map_pins/orange_pin.png";
import PinkPin from "./Map_pins/pink_pin.png";
import PurplePin from "./Map_pins/purple_pin.png";
import RedPin from "./Map_pins/red_pin.png";

import { Col, Row } from "react-bootstrap";
import Topbar from "../Topbar/Topbar";
import { FaWhatsapp } from "react-icons/fa6";

// Dynamic zoom tracking component
const ZoomHandler = ({ setZoom }) => {
  useMapEvents({
    zoomend: (e) => {
      setZoom(e.target.getZoom());
    },
  });
  return null;
};

const getDynamicIcon = (iconUrl, zoom) => {
  let size = 45;
  if (zoom < 12) size = 25;
  else if (zoom < 14) size = 35;
  else if (zoom < 16) size = 40;
  else size = 45;

  return new L.Icon({
    iconUrl: iconUrl,
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
    popupAnchor: [0, -size / 2],
  });
};

const MapView = () => {
  const apiURL = process.env.REACT_APP_API_BASE_URL;
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageType = queryParams.get("page");
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  const [counts, setCounts] = useState({
    Enquiry: 0,
    Installation: 0,
    Complaint: 0,
    Recovery: 0,
    Due: 0,
  });

  const [enquiryCounts, setEnquiryCounts] = useState({
    Open: 0,
    Hold: 0,
    Response: 0,
    Notfeasible: 0,
    Converted: 0,
    Cancelled: 0,
  });
  console.log(enquiryCounts);
  const [installationCounts, setInstallationCounts] = useState({
    Open: 0,
    Verified: 0,
    Fieldteamworking: 0,
    Activationpending: 0,
    Paymentdue: 0,
    Complete: 0,
    Cancelled: 0,
  });
  console.log(installationCounts);
  const [ComplaintCounts, setComplaintCounts] = useState({
    Open: 0,
    Fieldteamworking: 0,
    Networkteamworking: 0,
    Progress: 0,
    Completed: 0,
  });
  console.log(ComplaintCounts);
  const [DueCounts, setDueCounts] = useState({
    Open: 0,
    Paid: 0,
    Disable: 0,
    Reminder1: 0,
    Reminder2: 0,
    Reminder3: 0,
    MoreThan3Reminder: 0,
    Suspended: 0,
  });
  console.log(DueCounts);
  const [recoveryCounts, setRecoveryCounts] = useState({
    Open: 0,
    Progress: 0,
    Collected: 0,
    "Out Of Station": 0,
    "Not Handover": 0,
    "Not Available": 0,
    "Expect Renewal": 0,
  });
  console.log(recoveryCounts);
  const [visibleTaskTypes, setVisibleTaskTypes] = useState({
    Enquiry: true,
    Installation: true,
    Complaint: true,
    Recovery: true,
    Due: true,
  });

  //for popup
  const getStatusStyle = (status) => {
    switch (status) {
      case "Enquiry":
        return { backgroundColor: "#D3BDF2", color: "#4B2E83" };
      case "Installation":
        return { backgroundColor: "#B8E6C1", color: "#2F5D34" };
      case "Complaint":
        return { backgroundColor: "#FFB6DA", color: "#8B0000" };
      case "Due":
        return { backgroundColor: "#9FC8F2", color: "#003366" };
      case "Recovery":
        return { backgroundColor: "#D4AF87", color: "#5B3B1A" };
      default:
        return { backgroundColor: "#E0E0E0", color: "#000" };
    }
  };
  //end
  //task useeffet
  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const response = await axios.get(`${apiURL}/consolidated-data`);
        const data = response.data;

        // Count by type
        const typeCounts = {
          Enquiry: 0,
          Installation: 0,
          Complaint: 0,
          Recovery: 0,
          Due: 0,
        };

        data.forEach((item) => {
          if (item.type && typeCounts.hasOwnProperty(item.type)) {
            typeCounts[item.type]++;
          }
        });

        setCounts(typeCounts);
      } catch (error) {
        console.error("Error fetching task counts:", error);
      }
    };

    fetchCounts();
  }, []);
  //enquiry page
  useEffect(() => {
    axios
      .get(`${apiURL}/consolidated-data`)
      .then((res) => {
        // Filter only Enquiry type
        const enquiryData = res.data.filter(
          (item) => item.type && item.type.toLowerCase() === "enquiry"
        );

        // Count leadStatus values
        const counts = {
          Open: 0,
          Hold: 0,
          Response: 0,
          Notfeasible: 0,
          Converted: 0,
          Cancelled: 0,
        };

        enquiryData.forEach((item) => {
          const status = item.leadStatus?.trim() || "";
          if (status === "hold") counts.Hold++;
          else if (status === "open") counts.Open++;
          else if (status === "response") counts.Response++;
          else if (status === "notfeasible") counts.Notfeasible++;
          else if (status === "converted") counts.Converted++;
          else if (status === "cancelled") counts.Cancelled++;
        });

        // Update state
        setEnquiryCounts(counts);
      })
      .catch((err) => {
        console.error("Error fetching consolidated data:", err);
      });
  }, []);
  //instalation page
  useEffect(() => {
    axios
      .get(`${apiURL}/consolidated-data`)
      .then((res) => {
        // Filter only Installation type
        const installationData = res.data.filter(
          (item) => item.type && item.type.toLowerCase() === "installation"
        );

        // Count installation leadStatus values
        const counts = {
          Open: 0,
          Verified: 0,
          Fieldteamworking: 0,
          Activationpending: 0,
          Paymentdue: 0,
          Completed: 0,
          Cancelled: 0,
        };

        installationData.forEach((item) => {
          const status = item.leadStatus?.trim().toLowerCase() || "";
          if (status === "open") counts.Open++;
          else if (status === "verified") counts.Verified++;
          else if (status === "fieldteamworking") counts.Fieldteamworking++;
          else if (status === "activationpending") counts.Activationpending++;
          else if (status === "paymentdue") counts.Paymentdue++;
          else if (status === "completed") counts.Completed++;
          else if (status === "cancelled") counts.Cancelled++;
        });

        // Update state
        setInstallationCounts(counts);
      })
      .catch((err) => {
        console.error("Error fetching installation data:", err);
      });
  }, []);
  //Complaint page
  useEffect(() => {
    axios
      .get(`${apiURL}/consolidated-data`)
      .then((res) => {
        // Filter only Complaint type
        const complaintData = res.data.filter(
          (item) => item.type && item.type.toLowerCase() === "complaint"
        );

        // Initialize counts
        const counts = {
          Open: 0,
          Fieldteamworking: 0,
          Networkteamworking: 0,
          Progress: 0,
          Completed: 0,
        };

        // Loop through and increment counts
        complaintData.forEach((item) => {
          const status = item.leadStatus?.trim().toLowerCase() || "";

          if (status === "open") counts.Open++;
          else if (status === "fieldteamworking") counts.Fieldteamworking++;
          else if (status === "networkteamworking") counts.Networkteamworking++;
          else if (status === "progress") counts.Progress++;
          else if (status === "completed") counts.Completed++;
        });

        // Update state
        setComplaintCounts(counts);
      })
      .catch((err) => {
        console.error("Error fetching complaint data:", err);
      });
  }, [apiURL]);

  // useEffect for Due
  useEffect(() => {
    axios
      .get(`${apiURL}/consolidated-data`)
      .then((res) => {
        // Filter only Due type
        const dueData = res.data.filter(
          (item) => item.type && item.type.toLowerCase() === "due"
        );

        // Initialize counts
        const counts = {
          Open: 0,
          Paid: 0,
          Disable: 0,
          Reminder1: 0,
          Reminder2: 0,
          Reminder3: 0,
          MoreThan3Reminder: 0,
          Suspended: 0,
        };

        // Loop through and count statuses
        dueData.forEach((item) => {
          const status = item.dueStatus?.trim().toLowerCase() || "";

          if (status === "open") counts.Open++;
          else if (status === "paid") counts.Paid++;
          else if (status === "disable") counts.Disable++;
          else if (status === "reminder 1") counts.Reminder1++;
          else if (status === "reminder 2") counts.Reminder2++;
          else if (status === "reminder 3") counts.Reminder3++;
          else if (status === "> 3 reminder" || status === ">3 reminder")
            counts.MoreThan3Reminder++;
          else if (status === "suspended") counts.Suspended++;
        });

        // Update state
        setDueCounts(counts);
      })
      .catch((err) => {
        console.error("Error fetching consolidated data:", err);
      });
  }, [apiURL]);
  //recovery page
  useEffect(() => {
    axios
      .get(`${apiURL}/consolidated-data`)
      .then((res) => {
        // Filter only Recovery type
        const recoveryData = res.data.filter(
          (item) => item.type && item.type.toLowerCase() === "recovery"
        );

        // Initial counts
        const counts = {
          Open: 0,
          Progress: 0,
          Collected: 0,
          "Out Of Station": 0,
          "Not Handover": 0,
          "Not Available": 0,
          "Expect Renewal": 0,
        };

        // Loop and count leadStatus
        recoveryData.forEach((item) => {
          const status = item.leadStatus?.trim().toLowerCase() || "";

          if (status === "open") counts.Open++;
          else if (status === "progress") counts.Progress++;
          else if (status === "collected") counts.Collected++;
          else if (status === "out of station") counts["Out Of Station"]++;
          else if (status === "not handover") counts["Not Handover"]++;
          else if (status === "not available") counts["Not Available"]++;
          else if (status === "expect renewal") counts["Expect Renewal"]++;
        });

        setRecoveryCounts(counts);
      })
      .catch((err) => {
        console.error("Error fetching recovery data:", err);
      });
  }, [apiURL]);
  useEffect(() => {
    // Decide what to show in the modal
    if (!pageType) {
      // Default modal content
      setModalData({
        title: "Default Overview",
        stats: counts, // you already have default stats prepared
      });
    } else {
      // Page-specific stats
      const statsMap = {
        due: DueCounts,
        recovery: recoveryCounts,
        enquiry: enquiryCounts,
        installation: installationCounts,
        complaint: ComplaintCounts,
      };
      setModalData({
        title: `${
          pageType.charAt(0).toUpperCase() + pageType.slice(1)
        } Overview`,
        stats: statsMap[pageType] || {},
      });
    }
  }, [
    pageType,
    DueCounts,
    recoveryCounts,
    enquiryCounts,
    installationCounts,
    ComplaintCounts,
  ]);
  //states
  const [zoom, setZoom] = useState(13);
  const [mapData, setMapData] = useState([]);

  useEffect(() => {
    const iconMap = {
      Enquiry: EnquiryPin,
      Installation: InstallationPin,
      Complaint: ComplaintsPin,
      Due: DuePin,
      Recovery: RecoveryPin,
    };

    const fieldMap = {
      Enquiry: {
        name: "enquirycustomerName",
        phone: "enquirycontactNum",
        address: "enquiryaddress",
      },
      Installation: {
        name: "installcustomerName",
        phone: "installcontactNum",
        address: "installaddress",
      },
      Complaint: {
        name: "complaintcustomerAffected",
        phone: "complaintcontactNum",
        address: "complaintaddress",
      },
      Recovery: {
        name: "customername",
        phone: "contactnum",
        address: "address",
      },
      Due: {
        name: "customername", // Adjust if needed
        phone: "contactnum",
        address: "address",
      },
    };

    axios
      .get(apiURL + "consolidated-data")
      .then((res) => {
        if (res.status === 200) {
          const filteredMarkers = res.data
            .filter(
              (item) =>
                item.location &&
                typeof item.location === "object" &&
                item.location.latitude != null &&
                item.location.longitude != null
            )
            .map((item, index) => {
              const type = item.type;
              const mapping = fieldMap[type] || {};
              const location = item.location || {};

              let icon = iconMap[type] || EnquiryPin

              if(pageType === "enquiry"){
                if(item.leadStatus.toLowerCase() === "converted"){
                  icon = GreenPin
                }
                else if(item.leadStatus.toLowerCase() ==="open"){
                  icon =YellowPin//yellow color
                }
                  else if(item.leadStatus.toLowerCase()==="hold"){
                  icon =OrangePin//yellow color
                }
                  else if(item.leadStatus.toLowerCase() ==="noresponse"){
                  icon =PinkPin//yellow color
                }
                   else if(item.leadStatus.toLowerCase()==="notfeasible"){
                  icon =BluePin//yellow color
                }
                   else if(item.leadStatus.toLowerCase()==="cancelled"){
                  icon =RedPin//yellow color
                }
                
              }
              else if(pageType === "installation"){
                if(item.leadStatus === "completed"){
                  icon = GreenPin
                }
                else if(item.leadStatus==="open"){
                  icon = YellowPin//yellow color
                }
                  else if(item.leadStatus==="verified"){
                  icon = PurplePin//yellow color
                }
                  else if(item.leadStatus==="fieldteamworking"){
                  icon = OrangePin//yellow color
                }
                    else if(item.leadStatus==="activationpending"){
                  icon = BluePin//yellow color
                }
                  else if(item.leadStatus==="paymentdue"){
                  icon = PinkPin//yellow color
                }
               
                   else if(item.leadStatus==="cancelled"){
                  icon = RedPin//yellow color
                }
              }
               else if(pageType === "complaint"){
                if(item.leadStatus === "completed"){
                  icon = GreenPin
                }
                else if(item.leadStatus==="open"){
                  icon = YellowPin//yellow color
                }
                  else if(item.leadStatus==="fieldteamworking"){
                  icon = PurplePin//yellow color
                }
                  else if(item.leadStatus==="activationpending"){
                  icon = OrangePin//yellow color
                }
                    else if(item.leadStatus==="progress"){
                  icon = BlackPin//yellow color
                }
                
              }
              else if(pageType === "recovery"){
                if(item.leadStatus === "completed"){
                  icon = GreenPin
                }
                else if(item.leadStatus==="open"){
                  icon = YellowPin//yellow color
                }
                  else if(item.leadStatus==="out of station"){
                  icon = PurplePin//yellow color
                }
                  else if(item.leadStatus==="not handover"){
                  icon = RedPin//yellow color
                }
                    else if(item.leadStatus==="progress"){
                  icon = BlackPin//yellow color
                }
                     else if(item.leadStatus==="not available"){
                  icon = PinkPin//yellow color
                }
                     else if(item.leadStatus==="expect renewal"){
                  icon = BrownPin//yellow color
                }
                
              }



              return {
                id: item._id || index,
                position: [location.latitude, location.longitude],
                name: item[mapping.name] || "Unknown",
                phone: item[mapping.phone]?.toString() || "",
                address: item[mapping.address] || "",
                router: item.enquiryplanDetails?.enquiryrouterModel || "N/A",
                status: item.leadStatus || "",
                notes: item.enquiryleadStatus?.enquirynotes || "",
                type: type,
                icon: icon,
              };
            });

          console.log(filteredMarkers);

          if (pageType === "enquiry") {
            let tempData = filteredMarkers.filter(
              (item) => item.type === "Enquiry"
            );
            setMapData(tempData);
          } else if (pageType === "installation") {
            let tempData = filteredMarkers.filter(
              (item) => item.type === "Installation"
            );
            setMapData(tempData);
          } else if (pageType === "complaint") {
            let tempData = filteredMarkers.filter(
              (item) => item.type === "Complaint"
            );
            setMapData(tempData);
          } else if (pageType === "due") {
            let tempData = filteredMarkers.filter(
              (item) => item.type === "Due"
            );
            setMapData(tempData);
          } else if (pageType === "recovery") {
            let tempData = filteredMarkers.filter(
              (item) => item.type === "Recovery"
            );
            setMapData(tempData);
          } else {
            setMapData(filteredMarkers);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [apiURL]);
  const [visibleStatuses, setVisibleStatuses] = useState({
    // Enquiry statuses
    Open: true,
    Hold: true,
    Response: true,
    Notfeasible: true,
    Converted: true,
    Cancelled: true,

    // Installation statuses
    Open_Installation: true,
    Verified: true,
    Fieldteamworking: true,
    Activationpending: true,
    Paymentdue: true,
    Complete: true,
    Cancelled_Installation: true,

    // Complaint statuses
    Open_Complaint: true,
    Fieldteamworking_Complaint: true,
    Networkteamworking: true,
    Progress: true,
    Completed: true,

    // Due statuses
    Open_Due: true,
    Paid: true,
    Disable: true,
    Reminder1: true,
    Reminder2: true,
    Reminder3: true,
    MoreThan3Reminder: true,
    Suspended: true,

    // Recovery statuses
    Open_Recovery: true,
    Progress_Recovery: true,
    Collected: true,
    "Out Of Station": true,
    "Not Handover": true,
    "Not Available": true,
    "Expect Renewal": true,
  });

  // Filter map data based on visible statuses
 
const filteredMapData = mapData.filter((marker) => {
  // First check if the task type is visible
  if (!visibleTaskTypes[marker.type]) return false;

  // Get the status key based on type and status
  let statusKey = marker.status;
  console.log(statusKey,"statuskey");
  

  // Handle all status mappings consistently
  switch (marker.type) {
    case "Installation":
      if (statusKey === "Open_Installation") statusKey = "Open_Installation";
      else if (statusKey === "Cancelled_Installation") statusKey = "Cancelled_Installation";
      break;
    case "Complaint":
      if (statusKey === "Open_Complaint") statusKey = "Open_Complaint";
      else if (statusKey === "Fieldteamworking_Complaint") statusKey = "Fieldteamworking_Complaint";
      break;
    case "Due":
      if (statusKey === "Open") statusKey = "Open_Due";
      break;
        case "Enquiry":
      if (statusKey === "open") statusKey = "open";
      break;
    case "Recovery":
      if (statusKey === "Open") statusKey = "Open";
      else if (statusKey === "Progress") statusKey = "Progress_Recovery";
      // Keep other recovery statuses as-is since they match exactly
      break;
    // Enquiry statuses don't need modification
    default:
      break;
  }

  // Special handling for statuses with spaces
  const normalizedStatusKey = statusKey.replace(/\s+/g, ' ');
  
  // Check visibility in the state
  return visibleStatuses[normalizedStatusKey] !== false;
});

  const toggleTaskTypeVisibility = (type) => {
    setVisibleTaskTypes((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };
  // Toggle visibility for a specific status
  // const toggleStatusVisibility = (status) => {
  //   setVisibleStatuses((prev) => ({
  //     ...prev,
  //     [status]: !prev[status],
  //   }));
  // };
  const toggleStatusVisibility = (statusKey) => {
  setVisibleStatuses((prev) => ({
    ...prev,
    [statusKey]: !prev[statusKey],
  }));
};

  const getModalContent = () => {
    if (!pageType) {
      return (
        <div>
          <h4>Task Types</h4>
          {Object.keys(visibleTaskTypes).map((type) => (
            <div key={type} className="stat-item">
              <label>
                <input
                  type="checkbox"
                  checked={visibleTaskTypes[type]}
                  onChange={() => toggleTaskTypeVisibility(type)}
                />
                <span className="stat-name">{type}</span>
              </label>
            </div>
          ))}
        </div>
      );
    }

    // For specific pages, show status filters
    return (
      <div>
        <h4>Status Filters</h4>
       {getStatusesToShow().map((status) => {
  const statusKey = status.name + (pageType ? `_${pageType}` : "");
  return (
    <div key={statusKey} className="stat-item">
      <label>
        <input
          type="checkbox"
          checked={visibleStatuses[statusKey] !== false}
          onChange={() => toggleStatusVisibility(statusKey)}
        />
        <span className="stat-name">{status.name}</span>
      </label>
    </div>
  );
})}
      </div>
    );
  };

  // Get modal title based on page type
  const getModalTitle = () => {
    if (!pageType) return "Toggle Map Layers";

    const titles = {
      enquiry: "Enquiry Status Filters",
      installation: "Installation Status Filters",
      complaint: "Complaint Status Filters",
      due: "Due Status Filters",
      recovery: "Recovery Status Filters",
    };

    return titles[pageType] || "Toggle Map Layers"; // Changed default here
  };

  // Get statuses to show in modal based on page type
  const getStatusesToShow = () => {
    if (!pageType) {
      // Default task page list
      return [
        { name: "Enquiry" },
        { name: "Installation" },
        { name: "Complaint" },
        { name: "Due" },
        { name: "Recovery" },
      ];
    }

    if (pageType === "recovery") {
      return [
        { name: "Open" },
        { name: "Progress" },
        { name: "Collected" },
        { name: "Out Of Station" },
        { name: "Not Handover" },
        { name: "Not Available" },
        { name: "Expect Renewal" },
      ];
    } else if (pageType === "due") {
      return [
        { name: "Open" },
        { name: "Paid" },
        { name: "Disable" },
        { name: "Reminder1" },
        { name: "Reminder2" },
        { name: "Reminder3" },
        { name: "MoreThan3Reminder" },
        { name: "Suspended" },
      ];
    } else if (pageType === "enquiry") {
      return [
        { name: "Open" },
        { name: "Hold" },
        { name: "Response" },
        { name: "Notfeasible" },
        { name: "Converted" },
        { name: "Cancelled" },
      ];
    } else if (pageType === "complaint") {
      return [
        { name: "Open" },
        { name: "Fieldteamworking" },
        { name: "Networkteamworking" },
        { name: "Progress" },
        { name: "Completed" },
      ];
    } else if (pageType === "installation") {
      return [
        { name: "Open" },
        { name: "Verified" },
        { name: "Fieldteamworking" },
        { name: "Activationpending" },
        { name: "Paymentdue" },
        { name: "Completed" },
        { name: "Cancelled" },
      ];
    }

    // If some unknown pageType, return empty
    return [];
  };

  const renderStats = () => {
    if (pageType === "enquiry") {
      return (
        <Row className="row-width">
          {visibleStatuses["Open"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-2">
              <Row className="yellow-card">
                <p className="text-center box-txt" style={{ marginTop: "6px" }}>
                  Open
                </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {enquiryCounts["Open"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Hold"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="orange-card">
                <p className="text-center pt-1 box-txt">Hold</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {enquiryCounts["Hold"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Response"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="pink-card row-margin">
                <p className="text-center pt-1 box-txt">Response</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {enquiryCounts["Response"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Notfeasible"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="blue-card">
                <p className="text-center pt-1 px-1 box-txt">Not Feasible</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {enquiryCounts["Notfeasible"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Converted"] !== false && (
            <Col className="dashborder mx-1 mt-4 mb-5">
              <Row className="green-card">
                <p className="text-center pt-1 box-txt">Converted</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {enquiryCounts["Converted"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Cancelled"] !== false && (
            <Col className="dashborder mx-1 mt-4 mb-5">
              <Row className="red-card">
                <p className="text-center pt-1 box-txt">Cancelled</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {enquiryCounts["Cancelled"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}
        </Row>
      );
    } else if (pageType === "installation") {
      return (
        <Row className="row-width">
          {visibleStatuses.Open && (
            <Col className="dashborder mt-4 mb-5 mx-2">
              <Row className="yellow-card">
                <p className="text-center box-txt" style={{ marginTop: "8px" }}>
                  Open
                </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {installationCounts["Open"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses.Verified && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="purple-card">
                <p className="text-center pt-3 box-txt">Verified</p>
              </Row>
              <Row className="number">
                <h5 className="text-center">
                  {installationCounts["Verified"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses.Fieldteamworking && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="orange-card">
                <p className="text-center pt-1 box-txt">Field Team Working</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {installationCounts["Fieldteamworking"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses.Activationpending && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="blue-card row-margin">
                <p className="text-center pt-1 box-txt">Activation Pending</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {installationCounts["ActivationPending"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses.Paymentdue && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="pink-card">
                <p className="text-center pt-1 box-txt">Payment Due</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {installationCounts["PaymentDue"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses.Complete && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="green-card">
                <p className="text-center pt-1 px-1 box-txt">Completed</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {installationCounts["Completed"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses.Cancelled && (
            <Col className="dashborder mx-1 mt-4 mb-5">
              <Row className="red-card">
                <p className="text-center pt-1 box-txt">Cancelled</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {installationCounts["Cancelled"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}
        </Row>
      );
    } else if (pageType === "complaint") {
      return (
        <Row className="row-width">
          {visibleStatuses.Open && (
            <Col className="dashborder mt-4 mb-5 mx-2">
              <Row className="yellow-card">
                <p className="text-center box-txt" style={{ marginTop: "8px" }}>
                  Open
                </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {ComplaintCounts["Open"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses.Fieldteamworking && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="purple-card">
                <p className="text-center pt-3 box-txt">Field Team Working</p>
              </Row>
              <Row className="number">
                <h5 className="text-center">
                  {ComplaintCounts["Fieldteamworking"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses.Networkteamworking && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="orange-card">
                <p className="text-center pt-1 box-txt">Network Team Working</p>
              </Row>
              <Row className="number">
                <h5 className="text-center">
                  {ComplaintCounts["Networkteamworking"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses.Progress && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="grey-card row-margin">
                <p className="text-center pt-1 box-txt">Progress</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {ComplaintCounts["Progress"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses.Completed && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="green-card">
                <p className="text-center pt-1 box-txt">Completed</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {ComplaintCounts["Completed"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}
        </Row>
      );
    } else if (pageType === "due") {
      return (
        <Row className="row-width">
          {visibleStatuses["Open"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-2">
              <Row className="yellow-card">
                <p className="text-center box-txt" style={{ marginTop: "6px" }}>
                  Open
                </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{DueCounts["Open"] ?? 0}</h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Paid"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="green-card">
                <p className="text-center pt-1 box-txt">Paid</p>
              </Row>
              <Row className="number">
                <h5 className="text-center">{DueCounts["Paid"] ?? 0}</h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Reminder1"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="purple-card">
                <p className="text-center pt-1 box-txt">Reminder 1</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {DueCounts["Reminder 1"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Reminder2"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="brown-card row-margin">
                <p className="text-center pt-1 box-txt">Reminder 2</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {DueCounts["Reminder 2"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Reminder3"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="pink-card">
                <p
                  className="text-center pt-1 box-txt"
                  style={{ marginTop: "8px" }}
                >
                  Reminder 3
                </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {DueCounts["Reminder 3"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["MoreThan3Reminder"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="red-card">
                <p className="text-center pt-1 px-1 box-txt">&gt; 3 Reminder</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {DueCounts["> 3 Reminder"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Suspended"] !== false && (
            <Col className="dashborder mx-1 mt-4 mb-5">
              <Row className="grey-card">
                <p className="text-center pt-1 box-txt">Suspended</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {DueCounts["Suspended"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Disable"] !== false && (
            <Col className="dashborder mx-1 mt-4 mb-5">
              <Row className="orange-card">
                <p className="text-center pt-1 box-txt">Disable</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {DueCounts["Disable"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}
        </Row>
      );
    } else if (pageType === "recovery") {
      return (
        <Row className="row-width">
          {visibleStatuses["Open"] && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="yellow-card">
                <p
                  className="text-center box-txt"
                  style={{ marginTop: "15px" }}
                >
                  Open
                </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-2">
                  {recoveryCounts["Open"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Progress"] && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="grey-card">
                <p className="text-center box-txt">Progress</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {recoveryCounts["Progress"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Collected"] && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="green-card">
                <p className="text-center box-txt">Collected</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {recoveryCounts["Collected"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Out Of Station"] && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="purple-card row-margin">
                <p className="text-center box-txt">Out Of Station</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {recoveryCounts["Out Of Station"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Not Handover"] && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="red-card">
                <p className="text-center box-txt">Not Handover</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {recoveryCounts["Not Handover"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Not Available"] && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="pink-card">
                <p className="text-center px-1 box-txt">Not Available</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {recoveryCounts["Not Available"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Expect Renewal"] && (
            <Col className="dashborder mx-1 mt-4 mb-5">
              <Row className="brown-card">
                <p className="text-center box-txt">Expect Renewal</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {recoveryCounts["Expect Renewal"] ?? 0}
                </h5>
              </Row>
            </Col>
          )}
        </Row>
      );
    } else if (!pageType) {
      // This is the default case when no pageType is specified
      return (
        <Row className="row-width">
          {visibleStatuses["Enquiry"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-2">
              <Row className="purple-card">
                <p
                  className="text-center box-txt"
                  style={{ marginTop: "15px" }}
                >
                  Enquiry
                </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{counts.Enquiry}</h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Installation"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="green-card">
                <p className="text-center box-txt">Installation</p>
              </Row>
              <Row className="number">
                <h5 className="text-center">{counts.Installation}</h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Complaint"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="pink-card">
                <p className="text-center box-txt">Complaints</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{counts.Complaint}</h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Due"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="blue-card">
                <p className="text-center box-txt">Dues</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{counts.Due}</h5>
              </Row>
            </Col>
          )}

          {visibleStatuses["Recovery"] !== false && (
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="brown-card">
                <p className="text-center px-1 box-txt">Recovery</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{counts.Recovery}</h5>
              </Row>
            </Col>
          )}
        </Row>
      );
    }
  };
  return (
    <div className="p-4">
      <Topbar />

      {/* Status Filters Modal */}
      <Row>
        <Col md={11}>
          <h3 className="text-start"> My Task</h3>
        </Col>
        <Col md={1}>
          {!showStatsModal && (
            <img
              src={Map}
              alt="map"
              style={{ width: "30px", height: "30px" }}
              className="map-icon"
              onClick={() => setShowStatsModal(true)}
            />
          )}
        </Col>
      </Row>
      {renderStats()}
      {showStatsModal && (
        <div className="stats-modal">
          <div className="modal-header">
            <h5>{getModalTitle()}</h5>
            <button
              onClick={() => setShowStatsModal(false)}
              style={{
                color: "white",
                padding: "8px",
                backgroundColor: "red",
                border: "none",
                borderRadius: "5px",
              }}
            >
              ×
            </button>
          </div>
          <div className="modal-body">
            {getStatusesToShow().map((status) => (
              <div key={status.name} className="stat-item">
                <label>
                  <input
                    type="checkbox"
                    checked={visibleStatuses[status.name] !== false}
                    onChange={() => toggleStatusVisibility(status.name)}
                  />
                  <span className="stat-name">{status.name}</span>
                </label>
              </div>
            ))}
          </div>
        </div>
      )}

      <MapContainer
        center={[11.93994154695989, 79.76533154062585]}
        zoom={zoom}
        style={{ height: "500px", width: "100%" }}
      >
        <ZoomHandler setZoom={setZoom} />
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {filteredMapData.map((marker) => (
          <Marker
            key={marker.id}
            position={marker.position}
            icon={getDynamicIcon(marker.icon, zoom)}
          >
           <Popup minWidth={250}>
              <div className="enquiry-popup">
                {/* <button className="popup-close" onClick={onClose}>
                  &times;
                </button> */}

               
                <h3
                  className="enquiry-title"
                  style={{ color: getStatusStyle(marker.type).color }}
                >
                  {marker.type}
                </h3>

                <div className="enquiry-row">
                  <span className="enquiry-label">Name :</span>
                  <span className="enquiry-value">{marker.name}</span>
                </div>

                <div className="enquiry-row">
                  <span className="enquiry-label">Phone No :</span>
                  <a href={`tel:${marker.phone}`} className="enquiry-phone">
                    {marker.phone}
                  </a>
                </div>

                <div className="enquiry-row">
                  <span className="enquiry-label">Address :</span>
                  <div className="enquiry-value">{marker.address}</div>
                </div>

                <div className="enquiry-row">
                  <span className="enquiry-label">Status :</span>
                  <span
                    className={`enquiry-status ${
                      marker.status === "Open" ? "status-open" : "status-closed"
                    }`}
                    style={getStatusStyle(marker.type)}
                  >
                    {marker.status}
                  </span>
                </div>

                <div className="enquiry-row">
                  <span className="enquiry-label">Notes :</span>
                  <p className="enquiry-notes">{marker.notes}</p>
                  <div className="notes-icon">
                    <p className="enquiry-notes">{marker.notes}</p>
                    <a
                      href={`https://wa.me/${marker.phone}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="popup-whatsapp"
                    >
                      {/* <img src="/whatsapp-icon.png" alt="WhatsApp" /> */}
                      <FaWhatsapp size={25} color="#25D366" />
                    </a>
                  </div>
                </div>

                <a
                  href={`https://wa.me/${marker.phone}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="popup-whatsapp"
                >
                 
                </a>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default MapView;
